<template>
  <div class="p-4">
    <!-- 搜索表单 -->
    <div class="search-form-wrapper">
      <div class="search-form">
        <div class="search-item">
          <label>发布人:</label>
          <el-input v-model="searchText" placeholder="请输入发布人" clearable @keyup.enter.native="handleSearch"
            @clear="handleClear" style="width: 200px"></el-input>
        </div>
        <div class="search-buttons">
          <el-button @click="handleClear">清空</el-button>
          <el-button type="primary" @click="handleSearch">搜索</el-button>
          <el-button type="primary" @click="addPublisherAction">
            新增发布人
          </el-button>
        </div>
      </div>
    </div>

    <!-- 表格 -->
    <div class="mt-5">
      <el-card class="app-table-container" :body-style="{ padding: '20px' }">
        <div class="global-body-wrap">
          <appTable :tableProps="tableProps" :tableData="formattedTableData" :selectCtrl="false" :orderCtrl="true"
            :currentPage="params.page" :pageSize="params.pageSize" @tableHandle="tableHandle" />
        </div>
        <div style="display: flex; justify-content: flex-end; margin-top: 20px;">
          <pagination :currentPage="params.page" :pageSize="params.pageSize" :total="total" @pageNum="getPageNum" />
        </div>
      </el-card>
    </div>

    <!-- 发布人编辑对话框 -->
    <el-dialog :title="publisherDetails ? '编辑发布人' : '新增发布人'" :visible.sync="dialogVisible" width="800px"
      @close="handlePublisherDialogClose">
      <el-form :model="formData" :rules="rules" ref="publisherForm" label-width="180px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="头像（160 * 160px）" prop="avatar">
              <el-upload class="avatar-upload" action="" list-type="picture-card" accept=".png, .jpg, .bmp, .jpeg"
                :auto-upload="false" :show-file-list="false" :on-change="handleAvatarChange">
                <div v-if="formData.avatar" class="avatar-preview">
                  <img :src="formData.avatar" class="avatar-img" />
                  <div class="avatar-remove" @click.stop="removeAvatar">
                    <i class="el-icon-close"></i>
                  </div>
                </div>
                <i v-else class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="name" label-width="110px">
              <template slot="label">
                <div class="name-label-wrapper">
                  <div>发布人名称</div>
                  <span class="name-label-hint">（xx个字内）</span>
                </div>
              </template>
              <div class="name-inputs">
                <div class="name-input-item">
                  <span class="name-label">简体:</span>
                  <el-input v-model="valueByLanguage(formData.name, 'zh_CN').value" placeholder="请输入简体名称"
                    class="name-input"></el-input>
                </div>
                <div class="name-input-item">
                  <span class="name-label">繁体:</span>
                  <el-input v-model="valueByLanguage(formData.name, 'zh_TW').value" placeholder="请输入繁体名称"
                    class="name-input"></el-input>
                </div>
                <div class="name-input-item">
                  <span class="name-label">英文:</span>
                  <el-input v-model="valueByLanguage(formData.name, 'en').value" placeholder="请输入英文名称"
                    class="name-input"></el-input>
                </div>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label-position="top" prop="summary">
          <template slot="label">
            <div>
              <span>发布人介绍</span>
              <span class="summary-label-hint">（xx字以内）</span>
            </div>
          </template>
          <div class="summary-editor">
            <div class="summary-lang-tabs">
              <span v-for="lang in languages" :key="lang.value" class="lang-tab"
                :class="{ active: summaryLang === lang.value }" @click="changeSummaryLang(lang.value)">
                {{ lang.label }}
              </span>
            </div>
            <el-input v-model="valueByLanguage(formData.summary, summaryLang).value" type="textarea"
              :autosize="{ minRows: 12, maxRows: 12 }" :placeholder="`请输入${currentLangLabel}简介`"
              resize="none"></el-input>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handlePublisherDialogConfirm">
          确定
        </el-button>
      </div>
    </el-dialog>

    <!-- 操作详情对话框 -->
    <el-dialog title="操作详情" :visible.sync="optRecordVisible" width="80%" fullscreen>
      <opt-record :detailId="detailId" />
    </el-dialog>
  </div>
</template>

<script>
import appTable from "@/components/appTable";
import pagination from "@/components/pagination";
import listMixin from "@/mixins/list";
import OptRecord from "./components/optRecord/index.vue";
import api from "@/api";
import { valueByLanguage as valueByLanguageUtil, createLanguageData, getDefaultLanguageData } from "@/utils/college";
import { mapGetters } from "vuex";
import OSS from "ali-oss";

export default {
  name: "PublisherManagement",
  components: {
    appTable,
    pagination,
    OptRecord
  },
  mixins: [listMixin],
  computed: {
    ...mapGetters(["buckets"]),
    tableProps() {
      return [
        {
          prop: "id",
          label: "发布人ID"
        },
        {
          prop: "avatar",
          label: "头像",
          width: 70
        },
        {
          prop: "nameZh",
          label: "发布人（简体）"
        },
        {
          prop: "nameTw",
          label: "发布人（繁体）"
        },
        {
          prop: "nameEn",
          label: "发布人（英文）"
        },
        {
          prop: "summaryZh",
          label: "发布人介绍（简体）"
        },
        {
          prop: "summaryTw",
          label: "发布人介绍（繁体）"
        },
        {
          prop: "summaryEn",
          label: "发布人介绍（英文）"
        },
        {
          prop: "handle",
          label: "操作",
          width: 200,
          btn: ["编辑", "操作详情"]
        }
      ];
    },
    // 处理表格数据，添加格式化后的字段
    formattedTableData() {
      return this.tableData.map((row) => {
        return {
          ...row,
          // avatar 保持原值，用于显示图片
          nameZh: this.getValueByLanguage(row.name, "zh_CN", true) || "-",
          nameTw: this.getValueByLanguage(row.name, "zh_TW", true) || "-",
          nameEn: this.getValueByLanguage(row.name, "en", true) || "-",
          summaryZh: (() => {
            const summary = this.getValueByLanguage(row.summary, "zh_CN", true) || "";
            return summary ? (summary.length > 50 ? summary.substring(0, 50) + "..." : summary) : "-";
          })(),
          summaryTw: (() => {
            const summary = this.getValueByLanguage(row.summary, "zh_TW", true) || "";
            return summary ? (summary.length > 50 ? summary.substring(0, 50) + "..." : summary) : "-";
          })(),
          summaryEn: (() => {
            const summary = this.getValueByLanguage(row.summary, "en", true) || "";
            return summary ? (summary.length > 50 ? summary.substring(0, 50) + "..." : summary) : "-";
          })()
        };
      });
    },
    currentLangLabel() {
      const lang = this.languages.find(l => l.value === this.summaryLang);
      return lang ? lang.label : "";
    }
  },
  data() {
    return {
      params: {
        page: 1,
        pageSize: 20
      },
      searchText: "",
      tableData: [],
      total: 0,
      dialogVisible: false,
      optRecordVisible: false,
      detailId: null,
      publisherDetails: null,
      avatarFile: null,
      summaryLang: "zh_CN",
      languages: [
        { label: "简体", value: "zh_CN" },
        { label: "繁体", value: "zh_TW" },
        { label: "英文", value: "en" }
      ],
      formData: {
        avatar: "",
        name: getDefaultLanguageData(),
        summary: getDefaultLanguageData()
      },
      rules: {
        name: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const zhCN = valueByLanguageUtil(value, "zh_CN");
              if (!zhCN || !zhCN.value || !zhCN.value.trim()) {
                callback(new Error("请输入简体名称"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        summary: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const zhCN = valueByLanguageUtil(value, "zh_CN");
              const zhTW = valueByLanguageUtil(value, "zh_TW");
              const en = valueByLanguageUtil(value, "en");
              if (!zhCN || !zhCN.value || !zhCN.value.trim()) {
                callback(new Error("请填写发布人介绍（简体）"));
              } else if (!zhTW || !zhTW.value || !zhTW.value.trim()) {
                callback(new Error("请填写发布人介绍（繁体）"));
              } else if (!en || !en.value || !en.value.trim()) {
                callback(new Error("请填写发布人介绍（英文）"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        avatar: [{ required: true, message: "请上传头像", trigger: "change" }]
      }
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      api
        .getMaterialPublisherList(this.params)
        .then((res) => {
          this.tableData = res.data.items || [];
          this.total = res.data.count || 0;
        })
        .catch((err) => {
          this.$message.error(err.message || "获取列表失败");
        });
    },
    handleSearch() {
      this.params = {
        page: 1,
        pageSize: 20
      };
      if (this.searchText) {
        this.params.text = this.searchText;
      }
      this.getList();
    },
    handleClear() {
      this.searchText = "";
      this.params = {
        page: 1,
        pageSize: 20
      };
      this.getList();
    },
    getPageNum(page) {
      this.params.page = page;
      this.getList();
    },
    tableHandle(data) {
      // appTable 传递的是 { type, data: scope }，其中 scope 包含 row
      const row = data.data && data.data.row ? data.data.row : data.row;

      if (data.type === "编辑") {
        // 确保 row 存在且有 id
        if (row && row.id) {
          this.updatePublisherAction(row);
        } else {
          console.error("编辑失败：行数据无效", data, row);
        }
      } else if (data.type === "操作详情") {
        if (row && row.id) {
          this.openOptRecord(row);
        } else {
          console.error("操作详情失败：行数据无效", data, row);
        }
      }
    },
    addPublisherAction() {
      this.publisherDetails = null;
      this.summaryLang = "zh_CN";
      this.formData = {
        avatar: "",
        name: getDefaultLanguageData(),
        summary: getDefaultLanguageData()
      };
      this.avatarFile = null;
      this.dialogVisible = true;
    },
    updatePublisherAction(item) {
      if (!item || !item.id) {
        console.error("updatePublisherAction: item 无效", item);
        return;
      }

      // 从 tableData 中查找原始数据，因为 formattedTableData 可能没有原始的 name 和 summary 字段
      const originalItem = this.tableData.find(row => row && row.id === item.id);

      if (!originalItem) {
        console.error("updatePublisherAction: 找不到原始数据", item.id);
        return;
      }

      this.publisherDetails = originalItem;
      this.summaryLang = "zh_CN";
      // 使用 Object.assign 确保数组引用正确，与 galaxy 保持一致
      this.formData = {
        avatar: originalItem.avatar || "",
        name: Object.assign([], this.formData.name, originalItem.name || []),
        summary: Object.assign([], this.formData.summary, originalItem.summary || [])
      };
      this.avatarFile = null;
      this.dialogVisible = true;
    },
    handleAvatarChange(file) {
      const isImage =
        file.raw.type === "image/jpeg" ||
        file.raw.type === "image/png" ||
        file.raw.type === "image/bmp" ||
        file.raw.type === "image/jpeg";
      const isLt2M = file.raw.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error("上传头像图片只能是 JPG/PNG/BMP 格式!");
        return;
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
        return;
      }

      this.avatarFile = file.raw;
      // 创建预览 URL
      const url = URL.createObjectURL(file.raw);
      this.formData.avatar = url;
    },
    removeAvatar() {
      // 释放预览 URL
      if (this.formData.avatar && this.formData.avatar.startsWith("blob:")) {
        URL.revokeObjectURL(this.formData.avatar);
      }
      this.formData.avatar = "";
      this.avatarFile = null;
    },
    changeSummaryLang(lang) {
      this.summaryLang = lang;
    },
    // 上传头像到 OSS
    async uploadAvatarToOss(file) {
      if (!file) return this.formData.avatar;

      try {
        const sts = await api.aliyunSts();
        const { region, bucket } = this.buckets["onyx-static"] || {};

        if (!region || !bucket) {
          throw new Error("OSS 配置未找到");
        }

        const client = new OSS({
          region,
          accessKeyId: sts.data.AccessKeyId,
          accessKeySecret: sts.data.AccessKeySecret,
          stsToken: sts.data.SecurityToken,
          bucket,
          secure: true
        });

        const format = file.name.split(".").pop();
        const randomName = this.randomString(6) + "_" + new Date().getTime() + "." + format;
        const key = `publisher/avatar/${randomName}`;

        const result = await client.multipartUpload(key, file);
        const url = result.res.requestUrls[0].split("?")[0];

        // 释放预览 URL
        if (this.formData.avatar && this.formData.avatar.startsWith("blob:")) {
          URL.revokeObjectURL(this.formData.avatar);
        }

        return url;
      } catch (error) {
        console.error("头像上传失败:", error);
        this.$message.error("头像上传失败，请重试");
        throw error;
      }
    },
    randomString(len) {
      len = len || 32;
      const chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      const maxPos = chars.length;
      let pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },
    async handlePublisherDialogConfirm() {
      this.$refs.publisherForm.validate(async (valid) => {
        if (valid) {
          // 验证所有语言的 summary 都已填写
          const summaryZh = valueByLanguageUtil(this.formData.summary, "zh_CN");
          const summaryTw = valueByLanguageUtil(this.formData.summary, "zh_TW");
          const summaryEn = valueByLanguageUtil(this.formData.summary, "en");

          if (!summaryZh || !summaryZh.value || !summaryZh.value.trim()) {
            this.summaryLang = "zh_CN";
            this.$message.error("请填写发布人介绍（简体）");
            return;
          }
          if (!summaryTw || !summaryTw.value || !summaryTw.value.trim()) {
            this.summaryLang = "zh_TW";
            this.$message.error("请填写发布人介绍（繁体）");
            return;
          }
          if (!summaryEn || !summaryEn.value || !summaryEn.value.trim()) {
            this.summaryLang = "en";
            this.$message.error("请填写发布人介绍（英文）");
            return;
          }

          try {
            // 如果有新上传的头像文件，先上传到 OSS
            let avatarUrl = this.formData.avatar;
            if (this.avatarFile) {
              avatarUrl = await this.uploadAvatarToOss(this.avatarFile);
            }

            // 确保所有值都 trim 并正确设置
            const params = {
              name: this.formData.name.map(item => ({
                locale: item.locale,
                value: (item.value || "").trim()
              })),
              summary: this.formData.summary.map(item => ({
                locale: item.locale,
                value: (item.value || "").trim()
              })),
              avatar: avatarUrl
            };

            if (this.publisherDetails) {
              await api.updateMaterialPublisher(this.publisherDetails.id, params);
              this.$message.success("更新成功");
              this.dialogVisible = false;
              this.getList();
            } else {
              await api.addMaterialPublisher(params);
              this.$message.success("创建成功");
              this.dialogVisible = false;
              this.getList();
            }
          } catch (err) {
            this.$message.error(err.message || (this.publisherDetails ? "更新失败" : "创建失败"));
          }
        }
      });
    },
    handlePublisherDialogClose() {
      // 释放预览 URL
      if (this.formData.avatar && this.formData.avatar.startsWith("blob:")) {
        URL.revokeObjectURL(this.formData.avatar);
      }
      this.publisherDetails = null;
      this.summaryLang = "zh_CN";
      this.formData = {
        avatar: "",
        name: getDefaultLanguageData(),
        summary: getDefaultLanguageData()
      };
      this.avatarFile = null;
    },
    openOptRecord(row) {
      this.detailId = row.id;
      this.optRecordVisible = true;
    },
    getValueByLanguage(data, locale, returnValue = false) {
      return valueByLanguageUtil(data, locale, returnValue);
    },
    // 在模板中使用 valueByLanguage 需要暴露为方法
    valueByLanguage(data, locale) {
      return valueByLanguageUtil(data, locale);
    }
  }
};
</script>

<style scoped>
.search-form-wrapper {
  /* margin-bottom: 20px; */
  padding: 20px;
}

.search-form {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.search-item label {
  white-space: nowrap;
}

.search-buttons {
  display: flex;
  gap: 10px;
  margin-left: auto;
}

.summary-editor {
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 4px;
  overflow: hidden;
}

.summary-lang-tabs {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 8px 16px;
  border-bottom: 1px solid #ccc;
  background: #f5f5f5;
}

.lang-tab {
  cursor: pointer;
  padding: 4px 8px;
  color: #666;
}

.lang-tab:hover {
  color: #409eff;
}

.lang-tab.active {
  color: #409eff;
  font-weight: 500;
  text-decoration: underline;
}

:deep(.avatar-upload) {
  .el-upload {
    width: 106px;
    height: 106px;
  }
}

.avatar-preview {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  border-radius: 4px;
}

.avatar-img {
  width: 100%;
  height: 100%;
  object-fit: fill;
}

.avatar-remove {
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 0 0 0 8px;
}

.avatar-remove i {
  color: white;
  font-size: 16px;
}

.name-label-wrapper {
  display: flex;
  flex-direction: column;
  line-height: 1.5;
  padding-top: 5px;
}

.name-label-hint {
  font-size: 10px;
  color: #f56c6c;
}

.summary-label-hint {
  font-size: 10px;
  color: #f56c6c;
}

.name-inputs {
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
}

.name-input-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.name-label {
  width: 50px;
  white-space: nowrap;
  font-size: 14px;
}

.name-input {
  flex: 1;
}
</style>
